import './assets/css/base/base.scss'
import 'font-awesome/css/font-awesome.min.css';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './router.Interceptor';
import AppButton from './components/Button/button.component';
import FilterForm from './components/filterForm/filterForm.component';
import BasicTable from './components/table/table.component';
import CheckBox from './components/checkBox/checkBox.component';
import AppForm from './components/form/form.component';
//import * as custom from './api/dateFilter'
import './assets/iconfont/iconfont.css'
import moment from 'moment'

Vue.filter('dateFormat', function (dateStr, formatStr = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dateStr).format(formatStr)
})

Vue.use(Element)

Vue.config.productionTip = false

Vue.component('BasicTable', BasicTable);
Vue.component('FilterForm', FilterForm);
Vue.component('AppButton', AppButton);
Vue.component('CheckBox', CheckBox);
Vue.component('AppForm', AppForm);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
